export default {
  namespaced: true,
  state: {
    opened: false,
    questionIndex: null
  },
  mutations: {
    OPEN: (state, params) => {
      state.opened = true;
      if(params) {
        if(params.questionIndex) {
          state.questionIndex = params.questionIndex;
        }
        if(params.localStorage) {
          localStorage.setItem(params.localStorage, true);
        }
      }
    },
    CLOSE: (state) => {
      state.opened = false;
      state.questionIndex = null;
    },
  },
  actions: {
    openTutorial: ({commit}, params) => {
      commit('OPEN', params);
    },
    closeTutorial: ({commit}) => {
      commit('CLOSE');
    },
  },
  getters: {
    getState: (state) => {
      return state.opened;
    },
    getQuestionIndex: (state) => {
      return state.questionIndex;
    }
  }
}